import React from 'react';
import './Message.css';
import CloseIcon from '@mui/icons-material/Close';

const Message = ({ text, type, onClose }) => {
    let messageClass = 'message';
    if (type === 'error') {
        messageClass += ' error';
    } else if (type === 'warning') {
        messageClass += ' warning';
    } else if (type === 'info') {
        messageClass += ' info';
    } else if (type === 'success') {
        messageClass += ' success';
    }

    return (
        <div className={messageClass}>
            <span>{text}</span>
            <button className="close-button" onClick={onClose}>
                <CloseIcon fontSize="small" />
            </button>
        </div>
    );
};

export default Message;